export interface SurveyList {
  id: string;
  created_at: Date;
  name: string;
  survey_id: number;
  list_type: ListType;
  primary_list_id?: string;
}

export enum ListType {
  NORMAL_LIST = 'normalList',
  CONSTRUCTED_LIST = 'constructedList',
}
